<template>
  <!-- A link (or link-styled button) that reads as text rather than as a
       control. Same element choice as BaseButton: <button> without `href`,
       an external <a> in a new tab, or a <NuxtLink> for an in-app route.

       `muted`   footer and secondary navigation.
       `default` a standalone action beside a button ("Visit stripe.com →").
       `accent`  a link inside copy: indigo and underlined, so it isn't told
                 apart by colour alone.

       Size is inherited from the surrounding text. Slots: `icon`, default,
       `iconAfter` — with an icon the link lays out as a row. -->
  <component
    :is="tag"
    v-bind="linkAttrs"
    class="transition"
    :class="[TONES[tone], $slots.icon || $slots.iconAfter ? 'inline-flex items-center gap-1' : '']"
  >
    <slot name="icon" />
    <slot />
    <slot name="iconAfter" />
  </component>
</template>

<script setup>
import { usePolymorphicLink } from '~/composables/usePolymorphicLink'

const props = defineProps({
  href: { type: String, default: '' },
  tone: { type: String, default: 'default' },
})

const TONES = {
  muted: 'text-gray-400 hover:text-white',
  default: 'font-semibold text-gray-300 hover:text-white',
  accent: 'font-medium text-indigo-300 underline decoration-indigo-300/40 underline-offset-4 hover:text-indigo-200 hover:decoration-indigo-200',
}

const { tag, attrs: linkAttrs } = usePolymorphicLink(() => props.href)
</script>
